import { createAction } from '@reduxjs/toolkit';

import type {
    AvatarVoicePresetSelectionModalContext,
    ClipCreatorTemplatesModalContext,
    ClipPreviewModalContext,
    CreateBlueprintFromVideoDashboardModalContext,
    CreateBlueprintFromVideoModalContext,
    CreateBlueprintModalContext,
    CreateFolderModalContext,
    CreateSimilarVideoModalContext,
    CropModalContext,
    DeleteFolderModalContext,
    DeletePronunciationModalContext,
    EditPronunciationModalContext,
    FeatureLockModalContext,
    GenerativeMediaDetailsModalContext,
    GenericErrorModalContext,
    InsertTrimModalContext,
    MediaDetailsModalContext,
    MODAL_IDS,
    RecordYourScreenModalContext,
    RecordYourselfModalContext,
    RenameFolderModalContext,
    SketchBlueprintsModalContext,
    SketchTemplatesModalContext,
    SoundEffectSelectionModalContext,
    TranscriptGeneratedModalContext,
    TrimModalContext,
    UploadModalContext,
    UseCasePreviewModalContext,
    UserDropdownModalContext,
    VideoNameEditingModalContext,
    VoicedrivenSceneCreationModalContext,
    VoiceSelectionModalContext,
} from 'js/src/data/modals/modals-types';
import { MODALS_ACTIONS } from 'js/src/data/modals/modals-types';
import type { ImmutableMap } from 'js/src/libs/consts';

/**
 * Pushes the modal to show onto the top of the stack, along with any custom data
 *
 * @param modal_id one constant from MODAL_IDs
 * @param modal_context optional data that should be made available to the visible modal
 */
export interface ShowModalPayload {
    modal_id: MODAL_IDS;
    modal_context?:
        | ImmutableMap<UploadModalContext>
        | ImmutableMap<FeatureLockModalContext>
        | ImmutableMap<TranscriptGeneratedModalContext>
        | ImmutableMap<EditPronunciationModalContext>
        | ImmutableMap<MediaDetailsModalContext>
        | ImmutableMap<GenerativeMediaDetailsModalContext>
        | ImmutableMap<GenericErrorModalContext>
        | ImmutableMap<VoicedrivenSceneCreationModalContext>
        | ImmutableMap<CropModalContext>
        | ImmutableMap<TrimModalContext>
        | ImmutableMap<InsertTrimModalContext>
        | ImmutableMap<UserDropdownModalContext>
        | ImmutableMap<VoiceSelectionModalContext>
        | ImmutableMap<AvatarVoicePresetSelectionModalContext>
        | ImmutableMap<RecordYourselfModalContext>
        | ImmutableMap<RecordYourScreenModalContext>
        | ImmutableMap<DeletePronunciationModalContext>
        | ImmutableMap<CreateSimilarVideoModalContext>
        | ImmutableMap<CreateBlueprintFromVideoModalContext>
        | ImmutableMap<CreateBlueprintFromVideoDashboardModalContext>
        | ImmutableMap<ClipPreviewModalContext>
        | ImmutableMap<ClipCreatorTemplatesModalContext>
        | ImmutableMap<SketchTemplatesModalContext>
        | ImmutableMap<SketchBlueprintsModalContext>
        | ImmutableMap<VideoNameEditingModalContext>
        | ImmutableMap<CreateBlueprintModalContext>
        | ImmutableMap<RenameFolderModalContext>
        | ImmutableMap<DeleteFolderModalContext>
        | ImmutableMap<CreateFolderModalContext>
        | ImmutableMap<SoundEffectSelectionModalContext>
        | ImmutableMap<UseCasePreviewModalContext>;
}
export const showModal = createAction<ShowModalPayload>(MODALS_ACTIONS.SHOW_MODAL);

export const hideModal = createAction<undefined>(MODALS_ACTIONS.HIDE_MODAL);
